export namespace Assets {
  export const images = {
    avatar: "https://assets.iyk-dev.app/jennie/avatar.webp",
    og: "https://assets.iyk-dev.app/jennie/og-image.jpg",
    logo: "https://assets.iyk-dev.app/jennie/logo-white.webp",
    logoProfile: "https://assets.iyk-dev.app/jennie/logo-white.webp",
    layoutBackground: "https://assets.iyk-dev.app/jennie/layout-background.webp",
    tapEducationBackground: "https://assets.iyk.app/disturbed/tap_education_bg.png",
    // The enable location images object is globally used across all apps.
    // They are not specific to Disturbed, is just that Disturbed was the first app to use them.
    // So it's ok to keep using the disturbed bucket for now.
    enableLocation: {
      ios: {
        step1: "https://assets.iyk.app/disturbed/check-in/enable_location_ios_1.png",
        step2: "https://assets.iyk.app/disturbed/check-in/enable_location_ios_2.png",
      },
      android: {
        step1: "https://assets.iyk.app/disturbed/check-in/enable_location_android.png",
      },
    },
    email: {
      logo: "https://assets.iyk-dev.app/jennie/email/logo-gray.png",
    },
    roulette: [
      "https://assets.iyk-dev.app/jennie/roulette/1.webp",
      "https://assets.iyk-dev.app/jennie/roulette/2.webp",
      "https://assets.iyk-dev.app/jennie/roulette/3.webp",
      "https://assets.iyk-dev.app/jennie/roulette/4.webp",
    ],
    stageIcons: {
      birth: "https://assets.iyk.app/jennie/stage-icons/birth.webp",
      curiosity: "https://assets.iyk.app/jennie/stage-icons/curiosity.webp",
      love: "https://assets.iyk.app/jennie/stage-icons/love.webp",
      faith: "https://assets.iyk.app/jennie/stage-icons/faith.webp",
      zenith: "https://assets.iyk.app/jennie/stage-icons/zenith.webp",
      utopia: "https://assets.iyk.app/jennie/stage-icons/utopia.webp",
      legend: "https://assets.iyk.app/jennie/stage-icons/legend.webp",
    },
  }

  export const videos = {
    howToTapProfile: "https://assets.iyk.app/disturbed/how-to-tap-profile.mp4",
  }

  export const documents = {
    rules: "https://assets.iyk.app/disturbed/IYK-Disturbed-Official-Rules.pdf",
    privacyPolicy: "https://assets.iyk.app/iyk-privacy-policy.pdf",
    termsOfService: "https://assets.iyk.app/iyk-terms-of-service.pdf",
    sonyMusicPrivacyPolicy: "https://www.sonymusic.com/privacy-policy/",
  }
}
